//src/admin/features/accountants/accountantsModals/AddNewAccountantModal/index.tsx
import {
  useCreateNewAccountantMutation,
  useSignupAccountantMutation,
} from 'app/services/accountant';
import { CustomButton } from 'Components/Auth/CustomButton';
import { PhoneNumInput } from 'Components/Auth/PhoneInput';
import { TextInput } from 'Components/Auth/TextInput';
import Form from 'Components/Form';
import { errorToast, successToast } from 'Components/Notifications';
import OverlayWindow, { WindowSize } from 'Components/OverlayWindow';
import { useClosePopup } from 'Components/Popups';
import { SubmitHandler } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useAuth } from 'utils/AuthProvider';
import {
  FormInputsAddNewAccountant,
  validationSchemaAddNewAccountant,
} from '../formFields';

export default function AddNewAccountantModal() {
  const closePopup = useClosePopup();
  const [CreateNewAccountant] = useCreateNewAccountantMutation();
  const [AccountantSignup] = useSignupAccountantMutation();
  const { isAdmin } = useAuth();
  const dispatch = useDispatch();
  const onSubmit: SubmitHandler<FormInputsAddNewAccountant> = async (d) => {
    const data = {
      ...d,
      email: d.email.toLocaleLowerCase(),
    };
    closePopup();
    if (isAdmin) {
      CreateNewAccountant([data])
        .unwrap()
        .then(() => successToast('New Accoutant is Added Successfully'))
        .catch((e) => errorToast(e.data?.message));
    } else {
      AccountantSignup([data])
        .unwrap()
        .then(() => successToast('Accountant Signup request sent'))
        .catch((e) => errorToast(e.data?.message));
    }
  };

  let initialData: FormInputsAddNewAccountant = {
    given_name: '',
    family_name: '',
    email: '',
    title: '',
    phone_number: '',
  };

  return (
    <div>
      <OverlayWindow
        title={isAdmin ? 'Add New Accountant' : 'Accountant Signup'}
        subTitle={`Enter ${isAdmin ? 'accoutant' : 'your'} information`}
        onClose={closePopup}
        size={WindowSize.md}
        body={
          <Form
            onSubmit={onSubmit}
            defaultValues={initialData}
            validationSchema={validationSchemaAddNewAccountant}
          >
            {() => (
              <>
                <div className="flex w-full mb-3 md-max:grid ">
                  <div className="w-1/2 md-max:w-full">
                    <TextInput
                      name="given_name"
                      label="First Name"
                      placeholder="First Name"
                      type="text"
                    />
                  </div>
                  <div className="w-1/2 ml-4 md-max:w-full md-max:ml-0 md-max:mt-4">
                    <TextInput
                      name="family_name"
                      label="Last Name"
                      placeholder="Last Name"
                      type="text"
                    />
                  </div>
                </div>
                <div className="flex w-full mb-3 md-max:grid ">
                  <div className="w-full md-max:w-full">
                    <TextInput
                      name="email"
                      label="Email"
                      placeholder="Email"
                      type="text"
                    />
                  </div>
                </div>
                <div className="flex w-full mb-3 md-max:grid ">
                  <div className="w-full md-max:w-full">
                    <PhoneNumInput name="phone_number" label="Phone Number" />
                  </div>
                </div>
                <div className="flex w-full mb-3 md-max:grid ">
                  <div className="w-full md-max:w-full">
                    <TextInput
                      name="title"
                      label="Title"
                      placeholder="Title"
                      type="text"
                    />
                  </div>
                </div>
                <div className=" flex justify-between gap-5 pb-5">
                  <div className="w-1/2 flex flex-inline gap-4 mt-6 md-max:w-full md-max:grid">
                    <CustomButton
                      bgColor="gray-100"
                      textColor="gray-600"
                      text="Cancel"
                      borderColor="gray-100"
                      onClick={closePopup}
                    />
                  </div>
                  <div className="w-1/2 flex flex-inline gap-4 mt-6 md-max:w-full md-max:grid">
                    <CustomButton
                      type="submit"
                      text={isAdmin ? 'Add New Account' : 'Signup'}
                    />
                  </div>
                </div>
              </>
            )}
          </Form>
        }
      ></OverlayWindow>
    </div>
  );
}
